module.exports = __webpack_public_path__ + "static/media/individual-resource.1665dd87.svg";